import { Alert as MuiAlert, AlertProps as MuiAlertProps } from '@mui/material';

import React from 'react';

import { toSxArray } from '_lib/utils/helpers';

export type AlertProps = MuiAlertProps;

// Implement InfoAlert, SuccessAlert, etc, in the future as needed
export const WarningAlert = (props: AlertProps) => {
  const { sx, ...restProps } = props;

  return (
    <MuiAlert
      severity='warning'
      sx={[...toSxArray(sx), (theme) => ({ backgroundColor: theme.palette.warningExtras.lighter })]}
      {...restProps}
    />
  );
};

export const ErrorAlert = (props: AlertProps) => {
  const { sx, ...restProps } = props;

  return <MuiAlert severity='error' sx={[...toSxArray(sx)]} {...restProps} />;
};

export const InfoAlert = (props: AlertProps) => {
  const { sx, ...restProps } = props;

  return <MuiAlert severity='info' sx={[...toSxArray(sx)]} {...restProps} />;
};
